export const getScrollTop = () => (document.body.scrollTop || document.documentElement.scrollTop);
export const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;
